<template>
  <form class="form-horizontal">
    <div
      v-bind:class="{ 'has-error': $v.br[F_BUS].$invalid }"
      class="form-group"
    >
      <div class="col-4 col-sm-12">
        <label class="form-label" for="f-bus">From Bus</label>
      </div>
      <div class="col-8 col-sm-12">
        <div class="input-group">
          <input
            v-model.number="br[F_BUS]"
            class="form-input"
            id="f-bus"
            inputmode="numeric"
          />
          <button
            v-on:click="navigateToBus(br[F_BUS])"
            type="button"
            class="btn input-group-addon"
            aria-label="Navigate to 'from' bus"
          >
            <i v-if="busExists(br[F_BUS])" class="icon icon-arrow-right"></i>
          </button>
        </div>
        <p v-if="!$v.br[F_BUS].required" class="form-input-hint">
          From bus number is required.
        </p>
        <p v-else-if="!$v.br[F_BUS].integer" class="form-input-hint">
          From bus number must be an integer.
        </p>
        <p v-else-if="!$v.br[F_BUS].minValue" class="form-input-hint">
          From bus number must be >= 1.
        </p>
        <p v-else-if="!$v.br[F_BUS].exists" class="form-input-hint">
          From bus {{ br[F_BUS] }} must exist.
        </p>
      </div>
    </div>

    <div
      v-bind:class="{ 'has-error': $v.br[T_BUS].$invalid }"
      class="form-group"
    >
      <div class="col-4 col-sm-12">
        <label class="form-label" for="t-bus">To Bus</label>
      </div>
      <div class="col-8 col-sm-12">
        <div class="input-group">
          <input
            v-model.number="br[T_BUS]"
            class="form-input"
            id="t-bus"
            inputmode="numeric"
          />
          <button
            v-on:click="navigateToBus(br[T_BUS])"
            type="button"
            class="btn input-group-addon"
            aria-label="Navigate to 'to' bus"
          >
            <i v-if="busExists(br[T_BUS])" class="icon icon-arrow-right"></i>
          </button>
        </div>
        <p v-if="!$v.br[T_BUS].required" class="form-input-hint">
          To bus number is required.
        </p>
        <p v-else-if="!$v.br[T_BUS].integer" class="form-input-hint">
          To bus number must be an integer.
        </p>
        <p v-else-if="!$v.br[T_BUS].minValue" class="form-input-hint">
          To bus number must be >= 1.
        </p>
        <p v-else-if="!$v.br[T_BUS].exists" class="form-input-hint">
          To bus {{ br[T_BUS] }} must exist.
        </p>
      </div>
    </div>

    <div
      v-bind:class="{ 'has-error': $v.br[BR_STATUS].$invalid }"
      class="form-group"
    >
      <div class="col-4 col-sm-12">
        <label class="form-label" for="status">Status</label>
      </div>
      <div class="col-8 col-sm-12">
        <div class="input-group">
          <label class="form-checkbox">
            <input
              v-model.number="br[BR_STATUS]"
              v-bind:true-value="1"
              v-bind:false-value="0"
              type="checkbox"
              id="status"
            />
            <i class="form-icon"></i> In Service
          </label>
        </div>
        <p v-if="!$v.br[BR_STATUS].between" class="form-input-hint">
          Status must be 0 or 1.
        </p>
      </div>
    </div>

    <div
      v-bind:class="{ 'has-error': $v.br[BR_R].$invalid }"
      class="form-group"
    >
      <div class="col-4 col-sm-12">
        <label class="form-label" for="r">Resistance</label>
      </div>
      <div class="col-8 col-sm-12">
        <div class="input-group">
          <span class="input-group-addon">R</span>
          <input
            v-model.number="br[BR_R]"
            class="form-input"
            id="r"
            inputmode="decimal"
          />
          <span class="input-group-addon">pu</span>
        </div>
        <p v-if="!$v.br[BR_R].required" class="form-input-hint">
          Resistance is required.
        </p>
        <p v-else-if="!$v.br[BR_R].decimal" class="form-input-hint">
          Resistance must be a decimal.
        </p>
      </div>
    </div>

    <div
      v-bind:class="{ 'has-error': $v.br[BR_X].$invalid }"
      class="form-group"
    >
      <div class="col-4 col-sm-12">
        <label class="form-label" for="x">Reactance</label>
      </div>
      <div class="col-8 col-sm-12">
        <div class="input-group">
          <span class="input-group-addon">X</span>
          <input
            v-model.number="br[BR_X]"
            class="form-input"
            id="x"
            inputmode="decimal"
          />
          <span class="input-group-addon">pu</span>
        </div>
        <p v-if="!$v.br[BR_X].required" class="form-input-hint">
          Reactance is required.
        </p>
        <p v-else-if="!$v.br[BR_X].decimal" class="form-input-hint">
          Reactance must be a decimal.
        </p>
      </div>
    </div>

    <div
      v-bind:class="{ 'has-error': $v.br[BR_B].$invalid }"
      class="form-group"
    >
      <div class="col-4 col-sm-12">
        <label class="form-label" for="b">Charging Susceptance</label>
      </div>
      <div class="col-8 col-sm-12">
        <div class="input-group">
          <span class="input-group-addon">B</span>
          <input
            v-model.number="br[BR_B]"
            class="form-input"
            id="b"
            inputmode="decimal"
          />
          <span class="input-group-addon">pu</span>
        </div>
        <p v-if="!$v.br[BR_B].required" class="form-input-hint">
          Total line charging susceptance is required.
        </p>
        <p v-else-if="!$v.br[BR_B].decimal" class="form-input-hint">
          Total line charging susceptance must be a decimal.
        </p>
      </div>
    </div>

    <fieldset>
      <h6>Transformer</h6>

      <div
        v-bind:class="{ 'has-error': $v.br[TAP].$invalid }"
        class="form-group"
      >
        <div class="col-4 col-sm-12">
          <label class="form-label" for="tap">Turns Ratio</label>
        </div>
        <div class="col-8 col-sm-12">
          <div class="input-group">
            <span class="input-group-addon">&#120591;</span>
            <input
              v-model.number="br[TAP]"
              class="form-input"
              id="tap"
              inputmode="decimal"
            />
          </div>
          <p v-if="!$v.br[TAP].required" class="form-input-hint">
            Off nominal turns ratio is required.
          </p>
          <p v-else-if="!$v.br[TAP].decimal" class="form-input-hint">
            Off nominal turns ratio must be a decimal.
          </p>
          <p v-else-if="!$v.br[TAP].minValue" class="form-input-hint">
            Off nominal turns ratio must be >= 0.
          </p>
        </div>
      </div>

      <div
        v-bind:class="{ 'has-error': $v.br[SHIFT].$invalid }"
        class="form-group"
      >
        <div class="col-4 col-sm-12">
          <label class="form-label" for="shift">Phase Shift Angle</label>
        </div>
        <div class="col-8 col-sm-12">
          <div class="input-group">
            <span class="input-group-addon">&#1012;</span>
            <input
              v-model.number="br[SHIFT]"
              class="form-input"
              id="shift"
              inputmode="decimal"
            />
            <span class="input-group-addon">&deg;</span>
          </div>
          <p v-if="!$v.br[SHIFT].required" class="form-input-hint">
            Phase shift angle is required.
          </p>
          <p v-else-if="!$v.br[SHIFT].decimal" class="form-input-hint">
            Phase shift angle must be a decimal.
          </p>
        </div>
      </div>
    </fieldset>

    <fieldset>
      <h6>Limits</h6>

      <div
        v-bind:class="{ 'has-error': $v.br[RATE_A].$invalid }"
        class="form-group"
      >
        <div class="col-4 col-sm-12">
          <label class="form-label" for="rate-a">Rating</label>
        </div>
        <div class="col-8 col-sm-12">
          <div class="input-group">
            <input
              v-model.number="br[RATE_A]"
              class="form-input"
              id="rate-a"
              inputmode="decimal"
            />
            <span class="input-group-addon">MVA</span>
          </div>
          <p v-if="!$v.br[RATE_A].required" class="form-input-hint">
            MVA rating is required.
          </p>
          <p v-else-if="!$v.br[RATE_A].decimal" class="form-input-hint">
            MVA rating must be a decimal.
          </p>
        </div>
      </div>

      <div
        v-bind:class="{ 'has-error': $v.br[ANGMAX].$invalid }"
        class="form-group"
      >
        <div class="col-4 col-sm-12">
          <label class="form-label" for="ang-max">Maximum Angle</label>
        </div>
        <div class="col-8 col-sm-12">
          <div class="input-group">
            <input
              v-model.number="br[ANGMAX]"
              class="form-input"
              id="ang-max"
              inputmode="decimal"
            />
            <span class="input-group-addon">&deg;</span>
          </div>
          <p v-if="!$v.br[ANGMAX].required" class="form-input-hint">
            Maximum angle is required.
          </p>
          <p v-else-if="!$v.br[ANGMAX].decimal" class="form-input-hint">
            Maximum angle must be a decimal.
          </p>
          <p v-else-if="!$v.br[ANGMAX].between" class="form-input-hint">
            Maximum angle must be between -360 and 360.
          </p>
          <p v-else-if="!$v.br[ANGMAX].minValue" class="form-input-hint">
            Maximum angle must be >= {{ br[ANGMIN] }}.
          </p>
        </div>
      </div>

      <div
        v-bind:class="{ 'has-error': $v.br[ANGMIN].$invalid }"
        class="form-group"
      >
        <div class="col-4 col-sm-12">
          <label class="form-label" for="ang-min">Minimum Angle</label>
        </div>
        <div class="col-8 col-sm-12">
          <div class="input-group">
            <input
              v-model.number="br[ANGMIN]"
              class="form-input"
              id="ang-min"
              inputmode="decimal"
            />
            <span class="input-group-addon">&deg;</span>
          </div>
          <p v-if="!$v.br[ANGMIN].required" class="form-input-hint">
            Minimum angle is required.
          </p>
          <p v-else-if="!$v.br[ANGMIN].decimal" class="form-input-hint">
            Minimum angle must be a decimal.
          </p>
          <p v-else-if="!$v.br[ANGMIN].between" class="form-input-hint">
            Minimum angle must be between -360 and 360.
          </p>
          <p v-else-if="!$v.br[ANGMIN].maxValue" class="form-input-hint">
            Minimum angle must be &lt;= {{ br[ANGMAX] }}.
          </p>
        </div>
      </div>
    </fieldset>
  </form>
</template>

<script>
import {
  required,
  minValue,
  maxValue,
  integer,
  decimal,
  between
} from "vuelidate/lib/validators";

import MPCStore from "@/stores/MPCStore";

import {
  F_BUS,
  T_BUS,
  BR_R,
  BR_X,
  BR_B,
  RATE_A,
  TAP,
  SHIFT,
  BR_STATUS,
  ANGMIN,
  ANGMAX
} from "../../stores/idx";

export default {
  name: "BranchForm",
  props: ["ord"],
  data() {
    return {
      br: MPCStore.methods.getBranch(+this.ord - 1),
      F_BUS: F_BUS,
      T_BUS: T_BUS,
      BR_R: BR_R,
      BR_X: BR_X,
      BR_B: BR_B,
      RATE_A: RATE_A,
      TAP: TAP,
      SHIFT: SHIFT,
      BR_STATUS: BR_STATUS,
      ANGMIN: ANGMIN,
      ANGMAX: ANGMAX
    };
  },
  validations() {
    return {
      br: {
        [F_BUS]: {
          required,
          integer,
          minValue: minValue(1),
          exists: this.busExists
        },
        [T_BUS]: {
          required,
          integer,
          minValue: minValue(1),
          exists: this.busExists
        },
        [BR_R]: {
          required,
          decimal
        },
        [BR_X]: {
          required,
          decimal
        },
        [BR_B]: {
          required,
          decimal
        },
        [RATE_A]: {
          required,
          decimal,
          minValue: minValue(0)
        },
        [TAP]: {
          required,
          decimal,
          minValue: minValue(0)
        },
        [SHIFT]: {
          required,
          decimal
        },
        [BR_STATUS]: {
          between: between(0, 1)
        },
        [ANGMIN]: {
          required,
          decimal,
          between: between(-360, 360),
          maxValue: maxValue(this.br[ANGMAX])
        },
        [ANGMAX]: {
          required,
          decimal,
          between: between(-360, 360),
          minValue: minValue(this.br[ANGMIN])
        }
      }
    };
  },
  methods: {
    navigateToBus(n) {
      let idx = MPCStore.methods.findBusIdx(n);
      this.$router.push({ name: "bus", params: { ord: idx + 1 } });
    },
    busExists: n => MPCStore.methods.findBusIdx(n) >= 0
  }
};
</script>

<style lang="scss" scoped>
@import "../../main.scss";

fieldset {
  margin-top: 1rem;
  border-top: 0.05rem solid $gray-color;
  padding-top: 0.5rem;
}
</style>
